import React from 'react'
import FontAwesome from 'react-fontawesome'
import './status.scss'

const StatusButton = ({ status, addStatus }) => {
  const style = {
    color: status.color,
  }

  return (
    <button className="action-button" onClick={() => addStatus(status)}>
      <FontAwesome style={style} name={status.icon} />
      <span>{status.label}</span>
    </button>
  )
}

export default StatusButton
